module.exports = __webpack_public_path__ + "static/media/right_hover.e7e976bd.svg";